// Sort-direction labels follow the sorted field: names read A – Z, numbers 0 – 9.
export const sortingTypeLabel = (sortBy) =>
  sortBy === 'employeeNum'
    ? [
        { label: '0 - 9', value: 'asc' },
        { label: '9 - 0', value: 'desc' },
      ]
    : [
        { label: 'A - Z', value: 'asc' },
        { label: 'Z - A', value: 'desc' },
      ];
